import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import { useBrandPlan } from 'hooks/queries/brandPlans/useBrandPlan'
import { BrandAwarenessPlanTerminal } from './BrandPlanAwarenessTerminal'
import { BrandAwarenessPlanTerminalStepProps } from './Types'
import Styles from './BrandPlanAwarenessStep.module.scss'
import { useIsOnboardingRedesign } from 'hooks/useIsOnboardingRedesign'

export const BrandPlanAwarenessTerminalStep = ({ id, onNext, ...rest }: BrandAwarenessPlanTerminalStepProps) => {
  const { data: brandPlan } = useBrandPlan(id, { cacheTime: 60 * 1000 * 5 })
  const isOnboardingRedesign = useIsOnboardingRedesign()

  if (!brandPlan) return null

  return (
    <MultiStepStepLayout
      title="Review topics for your first week"
      description={
        isOnboardingRedesign
          ? 'Choose how frequently you want to post to each platform. You can adjust them any time.'
          : undefined
      }
      scrollContainerClassName={Styles.scrollContainer}
    >
      <BrandAwarenessPlanTerminal brandPlan={brandPlan} onNext={onNext} {...rest} />
    </MultiStepStepLayout>
  )
}
